import { Route } from '@angular/router';
import { content } from './content';
import { network } from './network';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../sb-routing-enum';
import { standardReporting } from './standardReporting';

export const reporting: Route = {
  path: 'reporting',
  title: 'nav.reporting',
  data: {
    icon: SbIcons.pieChart,
    breadcrumb: 'nav.reporting',
  },
  children: [content, network, standardReporting, { path: '', redirectTo: RoutingID.networkReporting, pathMatch: 'full' }],
};
